/* global process */
import store from "../../store";
const all = [];
const authenticated = (to, from, next) => {
    if (!store.getters.isLoggedIn) return next({ path: "/login", query: { next: to.fullPath } });
    return next(store.getters.userdata?.admin === true ? undefined : { path: "/" });
};
const page = () => import("./SgiPage.vue");
const route = (path, name, title, key, component, mode, groups = all) => ({
    path,
    name,
    component,
    props: { mode },
    beforeEnter: authenticated,
    meta: { menu: "segnalazioni", title, access: { key: "sgi.eventi." + key, defaultGroups: groups, admin: true } },
});
export default [
    { path: "/segnalazioni", redirect: { name: "SgiMie" } },
    { path: "/segnalazioni/eventi/", redirect: { name: "SgiMie" } },
    route("/segnalazioni/eventi/nuova/", "SgiNuova", "Nuova segnalazione", "invia", () => import("./SgiNewPage.vue")),
    route("/segnalazioni/eventi/mie/", "SgiMie", "Le mie segnalazioni", "propri", page, "mine"),
    route("/segnalazioni/eventi/gestione/", "SgiGestione", "Gestione segnalazioni", "analizza", page, "manage", all.slice(1)),
    route("/segnalazioni/eventi/cruscotto/", "SgiCruscotto", "Cruscotto SGI", "cruscotto", page, "dashboard", all.slice(1)),
    route("/segnalazioni/eventi/attivita/", "SgiAttivita", "Le mie azioni", "attivita", page, "tasks"),
    route("/segnalazioni/comunicazioni/", "SgiComunicazioni", "Comunicazioni", "comunicazioni", page, "communications"),
    route("/segnalazioni/eventi/:id/", "SgiDettaglio", "Dettaglio segnalazione", "dettaglio", () => import("./SgiDetailPage.vue")),
    ...(process.env.NODE_ENV === "development" ? [{
        path: "/segnalazioni/preview/",
        name: "SgiPreview",
        component: () => import("./SgiPreview.vue"),
        meta: { title: "Preview Segnalazioni", publicAuth: true },
    }] : []),
];
